// src/features/landing/presentation/pages/CompanyRegisterPage.jsx
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Footer } from "../components/Footer";
import "../styles/landing.css";

const JOB_CARDS = [
    {
        to: "/premium/company/rep",
        code: "INSURANCE_CEO",
        label: "보험 대리점 대표",
        desc: "지사 대표가 직접 작성하는 채용 신청서입니다.\n지사 현황 및 채용 조건을 상세히 입력해주세요.",
        icon: (
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
            </svg>
        ),
    },
    {
        to: "/premium/company/manager",
        code: "INSURANCE_EDU_MANAGER",
        label: "보험사 채용 담당자(설계매니저/교육매니저)",
        desc: "보험사 채용 담당자(설계매니저 또는 교육매니저) 채용 신청서입니다.\n지사 운영 현황 및 채용 조건을 입력해주세요.",
        icon: (
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="7" width="20" height="14" rx="2" />
                <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
                <line x1="12" y1="12" x2="12" y2="16" />
                <line x1="10" y1="14" x2="14" y2="14" />
            </svg>
        ),
    },
];

export function CompanyRegisterPage() {
    const location = useLocation();
    return (
        <>

            <div className="crb-page">

                {/* 헤더 */}
                <div className="crb-hero">
                    <div className="crb-hero-inner">
                        <p className="crb-hero-kicker">PREMIUM</p>
                        <h1 className="crb-hero-title">채용등록</h1>
                        <p className="crb-hero-sub">직무를 선택하여 채용 신청서를 작성해주세요.</p>
                    </div>
                </div>

                {/* 카드 목록 */}
                <div className="crb-body">
                    <p className="crb-guide">채용하실 직무를 선택해주세요.</p>
                    <div className="crb-cards">
                        {JOB_CARDS.map((card) => (
                            <Link key={card.code} to={card.to} state={location.state} className="crb-card">
                                <div className="crb-card-icon">{card.icon}</div>
                                <div className="crb-card-content">
                                    <p className="crb-card-label">{card.label}</p>
                                    <p className="crb-card-desc">
                                        {card.desc.split("\n").map((line, i) => (
                                            <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
                                        ))}
                                    </p>
                                </div>
                                <div className="crb-card-arrow">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="9 18 15 12 9 6" />
                                    </svg>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>

            <Footer />

            <style>{`
                .crb-page {
                    padding-top: 80px;
                    min-height: 100vh;
                    background: #f7f4f1;
                }

                /* 헤더 */
                .crb-hero {
                    background: linear-gradient(135deg, #fd7314 0%, #f1863f 100%);
                    padding: 48px 20px;
                    text-align: center;
                }
                .crb-hero-inner { max-width: 700px; margin: 0 auto; }
                .crb-hero-kicker {
                    font-size: 12px;
                    letter-spacing: 0.2em;
                    color: rgba(255,255,255,0.8);
                    font-weight: 600;
                    margin: 0 0 8px;
                }
                .crb-hero-title {
                    font-size: 2rem;
                    font-weight: 800;
                    color: #fff;
                    margin: 0 0 10px;
                }
                .crb-hero-sub {
                    font-size: 1rem;
                    color: rgba(255,255,255,0.85);
                    margin: 0;
                }

                /* 본문 */
                .crb-body {
                    max-width: 720px;
                    margin: 0 auto;
                    padding: 56px 20px 80px;
                }
                .crb-guide {
                    font-size: 0.88rem;
                    color: #888;
                    margin: 0 0 24px;
                    text-align: center;
                }

                /* 카드 목록 */
                .crb-cards {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                }
                .crb-card {
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    background: #fff;
                    border: 1.5px solid #e5ddd7;
                    border-radius: 16px;
                    padding: 28px 24px;
                    text-decoration: none;
                    color: inherit;
                    transition: border-color 0.2s, box-shadow 0.2s, transform 0.15s;
                }
                .crb-card:hover {
                    border-color: #f16102;
                    box-shadow: 0 6px 24px rgba(241,97,2,0.12);
                    transform: translateY(-2px);
                }
                .crb-card-icon {
                    flex-shrink: 0;
                    width: 64px;
                    height: 64px;
                    background: #fff5ee;
                    border-radius: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #f16102;
                    transition: background 0.2s;
                }
                .crb-card:hover .crb-card-icon { background: #fde8d8; }
                .crb-card-content { flex: 1; }
                .crb-card-label {
                    font-size: 1.1rem;
                    font-weight: 700;
                    color: #1c1814;
                    margin: 0 0 6px;
                }
                .crb-card-desc {
                    font-size: 0.85rem;
                    color: #888;
                    line-height: 1.65;
                    margin: 0;
                }
                .crb-card-arrow {
                    flex-shrink: 0;
                    color: #ccc;
                    transition: color 0.2s, transform 0.2s;
                }
                .crb-card:hover .crb-card-arrow {
                    color: #f16102;
                    transform: translateX(4px);
                }

                @media (max-width: 600px) {
                    .crb-hero-title { font-size: 1.5rem; }
                    .crb-card { padding: 22px 18px; gap: 16px; }
                    .crb-card-icon { width: 52px; height: 52px; }
                    .crb-card-label { font-size: 1rem; }
                }
            `}</style>
        </>
    );
}
